export default "__VITE_ASSET__Dbb_v5mB__"